import { render, staticRenderFns } from "./UserProfileTooltip.vue?vue&type=template&id=5176e041&scoped=true&"
import script from "./UserProfileTooltip.vue?vue&type=script&lang=ts&"
export * from "./UserProfileTooltip.vue?vue&type=script&lang=ts&"
import style0 from "./UserProfileTooltip.vue?vue&type=style&index=0&id=5176e041&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5176e041",
  null
  
)

export default component.exports